module.exports = __webpack_public_path__ + "img/icon-negative-survey.767181f7.svg";